import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppUrls } from 'src/app/helpers/app-urls';

@Injectable({
  providedIn: 'root'
})
export class CommentCategoryService {

  apiUrl: string;

  constructor(private httpclient: HttpClient) {
    const urls = new AppUrls();
    this.apiUrl = urls.apiUrl;
  }

  getCommentCategories(page: number, size: number, catid: number, orgid: number) {
    const urls = new AppUrls();
    this.apiUrl = urls.apiUrl;
    const url = this.apiUrl + '/api/commentcategory/v2/' + page + '/' + size + '/' + catid + '/' + orgid + '/';
    return this.httpclient.get<any>(url);
  }

}
